import { render, staticRenderFns } from "./cDocumentVersionComparePart.vue?vue&type=template&id=d6f98310&scoped=true"
import script from "./cDocumentVersionComparePart.vue?vue&type=script&lang=js"
export * from "./cDocumentVersionComparePart.vue?vue&type=script&lang=js"
import style0 from "./cDocumentVersionComparePart.vue?vue&type=style&index=0&id=d6f98310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f98310",
  null
  
)

export default component.exports